// extracted by mini-css-extract-plugin
module.exports = {"footer-add-buttons":"footer-add-buttons__footer-add-buttons___32dGW","credits-info":"footer-add-buttons__credits-info___1yQSD"};